import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StoreCommonService } from 'app/services/store/store-common.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-store-autocomplete',
  templateUrl: './store-autocomplete.component.html',
  styleUrls: ['./store-autocomplete.component.css']
})
export class StoreAutocompleteComponent implements OnInit {

  @Input() style: any = {'width':'100%'};
  @Input() inputStyle: any;
  @Input() filters: Array<{ key: string, value: string }>;
  @Input() disabled: any = false;
  @Input() storeDetailComplete: boolean = false;
  @Input() selectedStore: SelectItem;
  @Output() selectedStoreChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  

  storeList: SelectItem[];
  
  constructor(
    private storeService: StoreCommonService
  ) { }

  ngOnInit() {
  }
  

  
  getFilteredStores(event) {
    console.log(event.query)
    let params = [];
    if(this.filters) {
      this.filters.forEach(p => params.push(p));
    }
    console.log(params);
    if (event.query) {
      params.push({ 'key': 'store', 'value': event.query });
      this.storeService.getStoreByStore(params).subscribe(res => {
        this.storeList = res.map(store => ({label: `${store.host_code} - ${store.name}`, value: `${store.id}`}))
      });
    } else {
      this.storeList = [{ label: '', value: -1}];
      this.storeService.getStoreByStore(params).subscribe(res => {
        res.forEach(store => {
          if(store.name === undefined || store.name === null) {
            this.storeList.push({label: `${store.host_code} - --`, value: `${store.id}`})
          } else {
            this.storeList.push({label: `${store.host_code} - ${store.name}`, value: `${store.id}` })
          }
        });
      });
    }
  }

  getFilteredStoreDetails(event) {
    console.log(event.query)
    let params = [];
    if(this.filters) {
      this.filters.forEach(p => params.push(p));
    }
    console.log(params);
    if (event.query) {
      params.push({ 'key': 'storeDetails', 'value': event.query });
      this.storeService.getStoreByStoreDetails(params).subscribe(res => {
        this.storeList = res.map(store => ({label: `${store.host_code} - ${store.name}, ${store.address_1}, ${store.city}`, value: `${store.id}`}))
      });
    } else {
      this.storeList = [{ label: '', value: -1}];
      this.storeService.getStoreByStoreDetails(params).subscribe(res => {
        res.forEach(store => {
          if(store.name === undefined || store.name === null) {
            this.storeList.push({label: `${store.host_code} - --`, value: `${store.id}`})
          } else {
            this.storeList.push({label: `${store.host_code} - ${store.name}, ${store.address_1}, ${store.city}`, value: `${store.id}` })
          }
        });
      });
    }
  }

  changeStore(event) {
    console.log(event)
    this.selectedStoreChange.emit(event);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/store/store-autocomplete/store-autocomplete.component.ts